import type { PayerBillingConfig } from '../types/models/billing';

export interface PayerBillingProfile {
  id: string;
  label: string;
  description: string;
  config: PayerBillingConfig;
}

export const PAYER_BILLING_PROFILES: PayerBillingProfile[] = [
  {
    id: 'medicare_standard',
    label: 'Medicare Standard',
    description: '8-minute rule, NCCI edits, therapy modifiers, assistant modifiers, require minutes',
    config: {
      minute_rule: 'cms_8_minute',
      auto_therapy_modifiers: true,
      auto_assistant_modifiers: true,
      require_minutes: true,
      apply_ncci_edits: true,
      apply_icd10_excludes: true,
      // Matches the backend system default for medicare / medicare_advantage
      // (utils/expectedReimbursement.ts); shown as the resolved default in the UI.
      reimbursement: {
        percent_of_medicare: 100,
        apply_mppr: true,
        apply_assistant_reduction: true,
        assistant_reduction_pct: 15,
        apply_sequestration: true,
        sequestration_pct: 2,
        patient_share_pct: 20,
      },
    },
  },
  {
    id: 'commercial_standard',
    label: 'Commercial Standard',
    description: 'AMA midpoint rule, therapy modifiers, no NCCI edits',
    config: {
      minute_rule: 'ama_midpoint',
      auto_therapy_modifiers: true,
      auto_assistant_modifiers: false,
      require_minutes: false,
      apply_ncci_edits: false,
      apply_icd10_excludes: false,
    },
  },
  {
    id: 'workers_comp_standard',
    label: 'Workers Comp Standard',
    description: 'AMA midpoint rule, therapy modifiers, require minutes',
    config: {
      minute_rule: 'ama_midpoint',
      auto_therapy_modifiers: true,
      auto_assistant_modifiers: false,
      require_minutes: true,
      apply_ncci_edits: false,
      apply_icd10_excludes: false,
    },
  },
  {
    id: 'medicaid_standard',
    label: 'Medicaid Standard',
    description: 'AMA midpoint rule, therapy modifiers, NCCI edits',
    config: {
      minute_rule: 'ama_midpoint',
      auto_therapy_modifiers: true,
      auto_assistant_modifiers: false,
      require_minutes: true,
      apply_ncci_edits: true,
      apply_icd10_excludes: false,
    },
  },
  {
    id: 'custom',
    label: 'Custom',
    description: 'Manually configure all billing settings',
    config: {},
  },
];

export function getProfileForCategory(payerCategory?: string): PayerBillingProfile | undefined {
  if (!payerCategory) return undefined;
  if (payerCategory === 'medicare' || payerCategory === 'medicare_advantage') {
    return PAYER_BILLING_PROFILES.find(p => p.id === 'medicare_standard');
  }
  if (payerCategory === 'medicaid') {
    return PAYER_BILLING_PROFILES.find(p => p.id === 'medicaid_standard');
  }
  if (payerCategory === 'workers_comp') {
    return PAYER_BILLING_PROFILES.find(p => p.id === 'workers_comp_standard');
  }
  if (payerCategory?.startsWith('commercial') || payerCategory === 'auto' || payerCategory === 'tricare') {
    return PAYER_BILLING_PROFILES.find(p => p.id === 'commercial_standard');
  }
  return undefined;
}
